import { Reaction } from 'types/Reaction';

interface ReactionNames {
  [key: string] : string[];
}

interface ReactionCounts {
  [key: string] : number
}

export const getReactionCount = (reactions: Reaction[]): ReactionCounts => {
  let reactionCount: ReactionCounts = {}

  reactions.forEach(({ reaction }) => {
    if (reactionCount[reaction]) {
      reactionCount[reaction]++
    } else {
      reactionCount[reaction] = 1
    }
  })

  return reactionCount
}

export const getReactionNames = (reactions: Reaction[]): ReactionNames => {
  let reactionNames: ReactionNames = {}

  reactions.forEach(({ reaction, user }) => {
    if (reactionNames[reaction]) {
      reactionNames[reaction].push(user.name)
    } else {
      reactionNames[reaction] = [user.name]
    }
  })

  return reactionNames
}

export const reactionSentence = (names: String[], reaction: String) => {
  switch (names.length) {
    case 1:
      return `${names[0]} reacted with :${reaction}:`
    case 2:
      return `${names[0]} and ${names[1]} reacted with :${reaction}:`
    default:
      const characterLimit = 120
      const displayNames = names.slice(0, names.length - 1)
      const additionalName = names[names.length - 1]

      if (displayNames.join(', ').length > characterLimit) {
        const remainingNamesCount = names.length - 2
        return `${displayNames.slice(0, 2).join(', ')} and ${remainingNamesCount} ${
          remainingNamesCount === 1 ? 'other' : 'others'
        } reacted with :${reaction}:`
      }

      return `${displayNames.join(
        ', ',
      )} and ${additionalName} reacted with :${reaction}:`
  }
}
